import { useLingui } from '@lingui/react'
import { t } from '@lingui/macro'
import { Stack } from '@mui/material'

import useMetadataTitle from '@/hooks/useMetadataTitle'
import ChimeMeeting from '@/pages/diagnostic/containers/ChimeMeeting'

import { useVisioConferenceMeeting } from '../model/useVisioConferenceMeeting'

export function VisioConferencePage() {
  useLingui()
  useMetadataTitle(t`VisioConference`)
  const { join } = useVisioConferenceMeeting()

  return (
    <Stack height="100vh" sx={{ '& > div': { flex: 1 } }}>
      <ChimeMeeting joinMeeting={join} disableOpenInNewTab={true} />
    </Stack>
  )
}
